import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_SUBMIT_PARENT_PARTICULARS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostParentParticularsRequest {
  parentType: string;
  declaringPerson: {
    name: string;
    uinFinPassport: string
  },
  fatherDetail?: {
    name?: string;
    citizenship?: string;
    documentType?: string;
    documentNumber?: string;
    workPassType?: string;
    fin?: string
  },
  motherDetail?: {
    name?: string;
    citizenship?: string;
    documentType?: string;
    documentNumber?: string;
    workPassType?: string;
    fin?: string
  }
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSubmitParentParticulars = ({uuid, onSuccess, onError}: Input) => {
  const postSubmitParentParticulars = async (reqBody: PostParentParticularsRequest) => {
    await axiosClient.post(POST_SUBMIT_PARENT_PARTICULARS_URL(uuid), reqBody, {timeout: 20000});
  };

  return useCustomMutation(postSubmitParentParticulars, {
    onSuccess,
    onError,
  });
};
